<template>
  <div>
  </div>
</template>

<script>

export default {
  props: {
    solution: String,
    termId: String,
    search: String
  },
  mounted () {
    if (this.termId !== undefined && Number(this.termId) >= 1 && Number(this.termId) <= 4) {
      this.$router.push({ name: 'terms', params: { termId: this.termId }, props: true })
    } else if (this.search !== undefined && (this.search === 'true' || this.search === 'false')) {
      this.$router.push({ name: 'search', params: { search: this.search }, props: true })
    } else {
      this.$router.push({ name: 'select', params: { solution: this.solution }, props: true })
    }
  }
}

</script>
